import axios from "axios";
import { getSid } from "@/lib/events";

export const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const sid = getSid();
    if (sid) config.headers["X-Edi-Sid"] = sid;
    return config;
});

api.interceptors.response.use(undefined, (error) => {
    const { status, data } = error?.response || {};
    const url = error?.config?.url || "";
    if (status === 401 && !url.startsWith("/auth/login") && !url.startsWith("/auth/me")) window.dispatchEvent(new Event("edi:unauthorized"));
    if (status === 403 && data?.detail?.code === "password_change_required") window.dispatchEvent(new Event("edi:password-change"));
    return Promise.reject(error);
});

export function errorMessage(err, fallback = "Si è verificato un errore, riprova") {
    const detail = err?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === "string") return detail;
    if (detail.message) return detail.message;
    if (Array.isArray(detail)) return fallback;
    return fallback;
}

export function fieldErrors(err) {
    const detail = err?.response?.data?.detail;
    return detail && typeof detail === "object" && !Array.isArray(detail) ? detail.fields || null : null;
}

export function formatDate(isoString) {
    if (!isoString) return "";
    return new Date(isoString).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}
